enum Unity {
  Unspecified = 'Unspecified',
  Piece = 'Piece',
  Hour = 'Hour',
  FlatRate = 'FlatRate',
}

export default Unity;
